import React from 'react';
import PropTypes from 'prop-types';

/**
 * ErrorMessageHeader Component
 * Displays error message in a consistent format across the application
 * 
 * @param {Object} props - Component props
 * @param {string} props.message - Error message to display
 * @param {string} props.className - Additional CSS class for wrapper div
 */
function ErrorMessageHeader({ message, className = '' }) {
    if (!message) {
        return null;
    }

    return (
        <div className={`form-addTicket ${className}`.trim()}>
            <span className="error-message-header">
                {message}
            </span>
        </div>
    );
}

ErrorMessageHeader.propTypes = {
    message: PropTypes.string,
    className: PropTypes.string
};

export default ErrorMessageHeader;

